import { useMemo } from 'react';

/*
 * Given a filter record returns whether there's any
 * value in any of the record values
 */
export const useHasFilters = (filters: Record<string, null | unknown[]>) =>
  useMemo(() => {
    return Object.values(filters || {}).some((value) => !!value?.length);
  }, [filters]);
